import { FC } from 'react';
import { ModelWdollarPackage } from '~/models/model.wdollar.package';
import 'swiper/css';

export interface WdollarCardProps {
    item: ModelWdollarPackage;
    onClick?: (item: ModelWdollarPackage, e: React.MouseEvent<HTMLButtonElement>) => void;
    hideBuyButton?: boolean;
}

export const WdollarCard: FC<WdollarCardProps> = ({ item, onClick, hideBuyButton = false }) => {
    return (
        <div className="buy-now-item">
            <div className="buy-now-item-inner">
                {/* Image & Discount */}
                <div className="buy-now-img-wrap">
                    {item.discountText && (
                        <div className={`buy-now-discount ${item.freePlay ? 'freeplay' : 'extra'}`}>
                            {item.discountText}
                        </div>
                    )}
                    <figure>
                        <img src={`/assets/img/${item.package}-dollars.png`} alt={`$${item.package} pack`} />
                    </figure>
                </div>

                {/* Text Content */}
                <div className="buy-now-text-wrap">
                    {item.price && (
                        <>
                            <h4>
                                Exclusive Offer:
                                {item.freePlayText && (
                                    <span>
                                        <br />
                                        {item.freePlayText}
                                    </span>
                                )}
                            </h4>
                            {item.text && <p dangerouslySetInnerHTML={{ __html: item.text }} />}
                        </>
                    )}
                </div>

                {/* Optional Buy Button */}
                {!hideBuyButton && (
                    <div className="buy-now-btn-wrap">
                        <button type="button" className="btn" onClick={e => onClick && onClick(item, e)}>
                            {item.price ? `$${item.price}` : 'Buy Now'}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};
